module.exports = __webpack_public_path__ + "static/media/registered.831f4fa2.svg";